import { createFileRoute, Link } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { ButtonLink } from '@interxfi/design-system/components/button/button-link';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { AccountingManualEntriesTable } from '../../../../../../../../../features/accounting/manual-entry/accounting-manual-entries-table';
import { getPageHead } from '../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry/')({
  // staticData: {
  //   tab: {
  //     group: TabbedNavigationGroup.ClearingFinanceJournal,
  //     label: 'Entries',
  //     order: 0,
  //   },
  // } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinanceJournal>,
  head: () => getPageHead('Manual Entries'),
  component: AccountingManualEntryList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
        <RequiresAccess write>
          <ButtonLink
            affixIcon={<PlusIcon aria-hidden />}
            aria-label="Create a Journal Entry"
            LinkElement={Link}
            size="small"
            to="/clearing/finance/journal/create"
            variant="primary"
          />
        </RequiresAccess>
        {filter}
      </HorizontalStack>
    </HorizontalStack>
  );
}

function AccountingManualEntryList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <AccountingManualEntriesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
